import React, { useState, useEffect } from 'react';
import { Box, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { authService } from '../services/api';
import { ERAAssistantFAB } from './ERAAssistant';

const isElectron = typeof window !== 'undefined' && window.electronAPI?.isElectron === true;

const Layout = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem('era_user');
    if (userData) {
      setUser(JSON.parse(userData));
    }

    if (isElectron) {
      // En mode desktop : récupérer le profil local depuis le backend embarqué
      fetch('http://localhost:34512/api/desktop/profile')
        .then(r => r.json())
        .then(data => {
          if (data.profile) {
            const u = { id: 1, name: data.profile.full_name, role: 'admin' };
            setUser(u);
            localStorage.setItem('era_user', JSON.stringify(u));
          }
        })
        .catch(() => {});
    } else {
      authService.getCurrentUser().then(res => {
        setUser(res.data.user);
        localStorage.setItem('era_user', JSON.stringify(res.data.user));
      }).catch(console.error);
    }
  }, []);

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      bgcolor: 'background.default',
      backgroundImage: user?.dashboard_background ? `url(${user.dashboard_background})` : 'none',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      color: 'text.primary',
      transition: 'all 0.3s ease'
    }}>
      <Header user={user} setUser={setUser} />
      
      <Box component="main" sx={{ flexGrow: 1, py: { xs: 2, md: 4 } }}>
        <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2, md: 3 } }}>
          <Outlet context={{ user, setUser }} />
        </Container>
      </Box>

      {!isElectron && <ERAAssistantFAB />}
      <Footer />
    </Box>
  );
};

export default Layout;
